import React, { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';

import { getCookie } from '@ecp/common/src/utils/cookieUtils';
import { SITE_MOP, SiteNumberFunc } from '@ecp/common/src/const/site/siteNumberConst';

import useSiteInfo from '@fo-hooks/common/useSiteInfo';
import CookieGateLayout from '@fo-pages/member/login/CookieGateLayout';
import MopGateCodePage from '@fo-pages/member/login/MopGateCodePage';

/**
  ECMJ 프로그램 아이디 : PRG_EXON_02_01
  작업자 : 옥진호
 */

// 로그인 이전에 쿠키 분기가 필요한 경우, 아래에 해당 사이트의 쿠키 체크 페이지를 추가한다.
const COOKIE_GATE_PAGE_MAP = {
  [SITE_MOP]: MopGateCodePage,  // 우대몰 쿠키 체크 페이지
};

const getCookieGatePage = (siteNumber) => COOKIE_GATE_PAGE_MAP[siteNumber];

/**
 * 사이트 설정에 isCookieGateUseYn=true로 설정한 경우 처리된다.
 */
const CheckedCookieRoutes = () => {
  const { siteNumber } = useSiteInfo();

  const isCookieGateUseYn = SiteNumberFunc.isCookieGateUseYn(siteNumber);
  const cookieGateName = SiteNumberFunc.cookieGateName(siteNumber);
  const CookieGatePage = getCookieGatePage(siteNumber);

  const [hasAccess, setHasAccess] = useState(() => {
    if (!isCookieGateUseYn) {
      return true;
    }

    return !!getCookie(cookieGateName);
  });

  // cookieGateName 또는 쿠키 게이트 사용 여부가 확정/변경될 때실제 쿠키 값을 다시 읽어 hasAccess를 동기함.
  useEffect(() => {
    if (!isCookieGateUseYn || !cookieGateName) {
      setHasAccess(true);
      return;
    }

    setHasAccess(!!getCookie(cookieGateName));
  }, [cookieGateName, isCookieGateUseYn]);

  if (!isCookieGateUseYn || !cookieGateName || !CookieGatePage) {
    return <Outlet />;
  }

  if (!hasAccess) {
    // ECMJ PRG_EXON_02_01 (옥진호) : CookieGateLayout을 리턴하도록 변경.
    return (
      <CookieGateLayout>
        <CookieGatePage onSuccess={() => setHasAccess(true)} />
      </CookieGateLayout>
    );
  }

  return <Outlet />;
};

export default CheckedCookieRoutes;
